import React ,{ReactNode,FC}from 'react'

interface SectionTitleProps {
    children: ReactNode
}

export const SectionTitle:FC<SectionTitleProps> = ({children}) => {
  return (
      <h4 className='m-0 fw-semibold' style={{ fontSize:'15px', color:'#1D2939'}}>{children}</h4>
  )
}